@if (!isInline()) {
  <div class="modal-backdrop fade show" (click)="closed.emit()"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content" id="addFamilyMemberModal">
        <ng-container [ngTemplateOutlet]="formTpl"></ng-container>
      </div>
    </div>
  </div>
} @else {
  <div class="fm-inline-panel">
    <ng-container [ngTemplateOutlet]="formTpl"></ng-container>
  </div>
}

<ng-template #formTpl>
  <div class="fm-modal-header" [class.modal-header]="!isInline()">
    <h5 class="fm-head-20" [class.modal-title]="!isInline()">{{ editMember() ? 'Edit Family Member' : 'Add Family Member' }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closed.emit()"></button>
  </div>

  <form [formGroup]="memberForm" (ngSubmit)="onSubmit()" novalidate class="fm-add-member-form" id="addFamilyMemberModal">

    <div class="fm-modal-body" [class.modal-body]="!isInline()">

      <div class="row g-3">

        <!-- Family Group (add mode only) -->
        @if (!editMember()) {
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label class="fm-label">Family Group <span class="fm-required">*</span></label>
              <kendo-dropdownlist
                formControlName="selectedFamilySpaceId"
                [data]="familySpaces()"
                textField="familyName"
                valueField="id"
                [defaultItem]="{ id: '', familyName: 'Select family group' }"
                [valuePrimitive]="true"
                [class.is-invalid]="f['selectedFamilySpaceId'].invalid && f['selectedFamilySpaceId'].touched"
              ></kendo-dropdownlist>
              @if (f['selectedFamilySpaceId'].errors?.['required'] && f['selectedFamilySpaceId'].touched) {
                <div class="invalid-feedback d-block">Family group is required.</div>
              }
            </div>
          </div>
        }

                <!-- Relationship -->
        <div class="col-12 col-sm-6">
          <div class="form-group">
            <label class="fm-label">Relationship <span class="fm-required">*</span></label>
            <kendo-dropdownlist
              formControlName="relationship"
              [data]="relationshipOptions()"
              textField="name"
              valueField="id"
              [defaultItem]="{ id: null, name: 'Select relationship' }"
              [valuePrimitive]="true"
              [class.is-invalid]="f['relationship'].invalid && f['relationship'].touched"
            ></kendo-dropdownlist>
            @if (f['relationship'].errors?.['required'] && f['relationship'].touched) {
              <div class="invalid-feedback d-block">Relationship is required.</div>
            }
          </div>
        </div>

        <!-- First Name -->
        <div class="col-12 col-sm-6">
          <div class="form-group">
            <label class="fm-label">First Name <span class="fm-required">*</span></label>
            <input type="text" class="form-control" formControlName="firstName" appTrimWhitespace
              placeholder="Enter first name" [class.is-invalid]="f['firstName'].invalid && f['firstName'].touched" />
            @if (f['firstName'].errors?.['required'] && f['firstName'].touched) {
              <div class="invalid-feedback">First name is required.</div>
            }
            @if (f['firstName'].errors?.['minlength'] && f['firstName'].touched) {
              <div class="invalid-feedback">Must be at least 2 characters.</div>
            }
          </div>
        </div>

        <!-- Last Name -->
        <div class="col-12 col-sm-6">
          <div class="form-group">
            <label class="fm-label">Last Name <span class="fm-required">*</span></label>
            <input type="text" class="form-control" formControlName="lastName" appTrimWhitespace
              placeholder="Enter last name" [class.is-invalid]="f['lastName'].invalid && f['lastName'].touched" />
            @if (f['lastName'].errors?.['required'] && f['lastName'].touched) {
              <div class="invalid-feedback">Last name is required.</div>
            }
            @if (f['lastName'].errors?.['minlength'] && f['lastName'].touched) {
              <div class="invalid-feedback">Must be at least 2 characters.</div>
            }
          </div>
        </div>

        <!-- Email -->
        <div class="col-12 col-sm-6">
          <div class="form-group">
            <label class="fm-label">Email <span class="fm-required">*</span></label>
            <input type="email" class="form-control" formControlName="email" appTrimWhitespace
              placeholder="Enter email address" [class.is-invalid]="f['email'].invalid && f['email'].touched"
              [readonly]="!!editMember()" />
            @if (f['email'].errors?.['required'] && f['email'].touched) {
              <div class="invalid-feedback">Email is required.</div>
            }
            @if (f['email'].errors?.['email'] && f['email'].touched) {
              <div class="invalid-feedback">Please enter a valid email.</div>
            }
          </div>
        </div>

        <!-- Phone -->
        <div class="col-12 col-sm-6">
          <div class="form-group">
            <label class="fm-label">Phone <span class="fm-optional-tag">(Optional)</span></label>
            <input type="tel" class="form-control" formControlName="phoneNumber" appPhoneFormat
              placeholder="Enter phone number" />
          </div>
        </div>

        <!-- Upload photo (optional) -->
        <div class="col-12">
          <div class="fm-optional-fileupload">
            <label class="fm-label mb-2">Upload Photo <span class="fm-optional-tag">(Optional)</span></label>
            @if (isFetchingDetail()) {
              <div class="fm-fileupload fm-fileupload-dashed d-flex align-items-center justify-content-center">
                <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                <span>Loading...</span>
              </div>
            } @else if (!photoPreview()) {
              <label class="fm-fileupload fm-fileupload-dashed" [class.disabled]="isPhotoUploading()"
                [class.fm-drag-over]="isPhotoDragOver()"
                (dragover)="onPhotoDragOver($event)"
                (dragleave)="onPhotoDragLeave($event)"
                (drop)="onPhotoDrop($event)">
                <div class="fm-upload-content text-center">
                  @if (isPhotoUploading()) {
                    <span class="spinner-border spinner-border-sm" role="status"></span>
                    <p class="mb-0">Uploading…</p>
                  } @else {
                    <img src="images/icons/fm-upload-icon.svg" class="fm-svg mb-2" alt="Upload" />
                    <p class="mb-0">Drop your photo here, or <span class="fm-browse-link">Browse</span></p>
                    <p class="mb-0 fm-upload-formats">Supported formats: JPG, JPEG, PNG, GIF, WebP, SVG</p>
                  }
                </div>
                <input type="file" accept="image/*" class="d-none"
                  (change)="onPhotoSelected($event)" [disabled]="isPhotoUploading()" />
              </label>
            } @else if (photoPreview()) {
              <div class="fm-img-preview-block">
                <div class="fm-img-preview-thumb-wrap">
                  <img [src]="photoPreview()" class="fm-img-preview-thumb" alt="Photo Preview" />
                  @if (isPhotoUploading()) {
                    <div class="fm-img-uploading-overlay">
                      <span class="spinner-border spinner-border-sm" role="status"></span>
                    </div>
                  }
                  <button
                    type="button"
                    class="fm-img-remove-corner"
                    (click)="removePhoto()"
                    [disabled]="isPhotoUploading()"
                    aria-label="Remove photo"
                  >
                    <i class="bi bi-x"></i>
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      </div>

    </div>

    <div class="fm-modal-footer">
      <div class="row g-2 w-100 justify-content-end">
        <div class="col-12 col-sm-auto">
          <button type="button" class="fm-common-btn fm-border-btn w-100" (click)="closed.emit()">
            Cancel
          </button>
        </div>
        <div class="col-12 col-sm-auto">
          <button type="submit" class="fm-common-btn w-100" [disabled]="isLoading()">
            @if (isLoading()) {
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>
              {{ editMember() ? 'Updating...' : 'Adding...' }}
            } @else {
              {{ editMember() ? 'Update Member' : 'Add Member' }}
            }
          </button>
        </div>
      </div>
    </div>

  </form>
</ng-template>
